{
  "loadMap": "I-load ang mapa",
  "lowDataNote": "Naka-on ang low-data mode, kaya maglo-load lang ang mapa kapag hiniling mo.",
  "unavailable": "Hindi maipakita ang mapa sa device na ito. Gamitin ang listahan sa ibaba.",
  "usingOffline": "Offline na mapa",
  "usingFallback": "Backup na mapa",
  "tapToPlace": "I-tap ang mapa para ilagay ang pin, o gamitin ang iyong lokasyon.",
  "locateFailed": "Hindi makuha ang iyong lokasyon. I-drag ang pin o i-tap ang mapa."
}
